import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';
import Raven from 'raven-js';
import { chirpClient } from '../../clients/chirpClient';
import { previewLoginVerifyRpc } from '../../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerPreviewLoginRpc';
import { ErrorActions } from '../../constants/ErrorActions';
import { RequestStatus } from '../../constants/RequestStatus';
const initialState = {
  isLoggedIn: false,
  requestStatus: RequestStatus.UNINITIALIZED,
  initialized: false,
  error: undefined
};
export const previewLoginVerified = createAsyncThunk('auth/previewLoginVerified', async previewJwt => {
  try {
    const response = await chirpClient.call(previewLoginVerifyRpc, {
      request: {
        previewJwt
      }
    });
    if (!response.hasAccess) {
      var _response$denialReaso;
      throw new Error((_response$denialReaso = response.denialReason) !== null && _response$denialReaso !== void 0 ? _response$denialReaso : 'Preview access denied');
    }
    return response;
  } catch (error) {
    Raven.captureException(error instanceof Error ? error : new Error(String(error)), {
      tags: {
        action: ErrorActions.LOGIN_VERIFIED
      }
    });
    throw error;
  }
});
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(previewLoginVerified.fulfilled, state => {
      state.initialized = true;
      state.isLoggedIn = true;
    }).addCase(previewLoginVerified.rejected, state => {
      state.initialized = true;
      state.isLoggedIn = false;
    }).addMatcher(isAnyOf(previewLoginVerified.pending), state => {
      state.requestStatus = RequestStatus.PENDING;
      state.error = undefined;
    }).addMatcher(isAnyOf(previewLoginVerified.fulfilled), state => {
      state.requestStatus = RequestStatus.SUCCEEDED;
    }).addMatcher(isAnyOf(previewLoginVerified.rejected), (state, action) => {
      var _action$error;
      state.requestStatus = RequestStatus.FAILED;
      state.error = (_action$error = action.error) === null || _action$error === void 0 ? void 0 : _action$error.message;
    });
  }
});
export default authSlice.reducer;